module.exports = __webpack_public_path__ + "img/Portafolio Kuida 2.ac7cfe3a.png";